var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinilautern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "minilautern_svg__Layer_1",
    viewBox: "0 0 1812.05 1253.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n   .minilautern_svg__cls-1{opacity:0.3}.minilautern_svg__cls-2{fill:#c66378}.minilautern_svg__cls-3{fill:#e0e0e0}\r\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "minilautern_svg__Group_28",
    className: "minilautern_svg__cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "minilautern_svg__Group_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "minilautern_svg__Path_62-2",
    d: "M121.44,567.83,198.27,631l193.52,127.4L576.56,871.25l255.76,130.31L864.41,1020l158.52,59.32,97.25,33.06,165.32,44.74,71-115.4,31.12-40.2,42.79-53.17,45.38-50.56,55.75-61,83-93.35,42.79-48,84.28-127.72L1822,447.89,1914,315.64l19.45-23.34-33.71-20.75L1739,99.1,1604.15-68.17l-23.34-28.52L1438.18,12.22l-198.39,99.85-67.42-40.2L1036.22,223.58l-93.36,85.57L840.43,376.58Z",
    className: "minilautern_svg__cls-2",
    transform: "translate(-121.44 96.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "minilautern_svg__Path_63",
    d: "M1348.52,1054.71l-143.74-178.6,143-102.11,99.19-71,14.59-21.39,104-72L1592.8,562,1447.9,360.7V344.17l184.77-147.82,72.94-53.49L1739,99.1l-14.12-17.52-45.52,44.75-78.77,69.05-136.64,116.7-42.3,21.39L1260,101.9l-20.2,10.17,163.38,225.29-1,15.56-45.7,42.79L1198,509.49l-17.5,10.7L1126,455l-81.69-116.7L1027.47,350l84,108.92L1162,530.24l-34,26.9-95.3,66.13-64.18-76.83L870.25,422l-68.73,28.95,46.68,56.62,9.4,33.82L989.87,718.57l-36,33.07,49.6,76.82L1090,777.89l60.3,86.56-178,142.95-23.59,44.21,18.16,6.8,16.12-40.31L1163,880l74.88,92.39-20.43,18.48,101.19,112.46Z",
    className: "minilautern_svg__cls-3",
    transform: "translate(-121.44 96.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "minilautern_svg__Path_64",
    d: "M212.7,543.56s17.87,28.38,20.9,31.41,24.64,22,24.64,22,26.36,15.13,31.11,16.43,32.42,0,32.42,0,43.22-7.35,47.54-9.08,45.82-9.08,48.41-9.08,52.73-9.51,52.73-9.51l48-9.5,48-7.78,29-3.89,55.32-32.42,94.66-57.92,16-12.1h18.59l21.61-11.23,46.68,56.62-35,24.92-35.88-46.1-30.68,8.21L723.73,508l-36.31,22.26-56.18,36.09-29,12.78-23.77,4.51L501.14,597,414.7,614s-38.47,6.34-41.5,7.2-19.88,5.19-28.95,6.49c-9.78,1.4-35.88,5.18-35.88,5.18s-20.74,1.73-36.74-4.75-32-21.18-32-21.18l-18.58-19-26.65-39.52Z",
    className: "minilautern_svg__cls-3",
    transform: "translate(-121.44 96.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "minilautern_svg__Path_65",
    d: "M1188.25,856.66l381.21-277.55L1437.2,387l-22.36-9.73L1039.46,653.42l3.89,19.45Z",
    className: "minilautern_svg__cls-2",
    transform: "translate(-121.44 96.69)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "minilautern_svg__Path_66",
    d: "M1565.57,609.65l94.12,82.3,34.6-52.43L1592.8,562Z",
    className: "minilautern_svg__cls-3",
    transform: "translate(-121.44 96.69)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinilautern);
export default __webpack_public_path__ + "static/media/minilautern.29e8fdacd69b96374e22f6f5091cd604.svg";
export { ForwardRef as ReactComponent };